module.exports = __webpack_public_path__ + "static/media/SPRAY1.41d4194a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY1.png
// module id = 283
// module chunks = 0